<h2 mat-dialog-title>Create New Folder</h2>
<form
  mat-dialog-content
  class="form"
  [formGroup]="form"
  cdkTrapFocus
  [cdkTrapFocusAutoCapture]="true"
>
  <mat-form-field>
    <mat-label>Folder name</mat-label>
    <input
      matInput
      cdkFocusInitial
      type="text"
      formControlName="name"
      (keydown.enter)="confirm()"
    />
    @if (form.hasError("required", "name")) {
      <mat-error>The folder name is <strong>required</strong></mat-error>
    }
  </mat-form-field>
</form>
<div mat-dialog-actions>
  <button mat-button (click)="close()" [disabled]="isCreating">Close</button>
  <button mat-flat-button color="primary" (click)="confirm()" [disabled]="isCreating">
    Create
  </button>
</div>
